import { baseUrl } from "../../../boot/index";
import axios from "axios";

// Add company
export const addCustomerLedger = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/crm/app/v1/create-customer-ledger`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log({error})
    throw error
  }
}


// delete CustomerLedger 
export const deleteCustomerLedger= async (ROWID) => {
  console.log({ROWID})
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/crm/app/v1/delete-customer-ledger/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ",error)
    throw error
  }
}
// update CustomerLedger
export const updateCustomerLedger = async (ROWID, data) => {
  console.log({data})
  // const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/crm/app/v1/update-customer-ledger/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
// total count
export const countCustomerLedger = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/count-customer-ledger`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}



export const getCustomerLedgerById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/getlistbyid-customer-ledger/${id}`, {
      headers: {
        "auth-token": token,
      }
    })
    // console.log('<<<<<<<<<<<<<<<<<<<<<companires>>>>>>>>>>>>>>>>>',response)
    return response
  } catch (error) {
    throw error
  }
}